import { useRef, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { FileUp, Loader2, Download } from "lucide-react";

const TEMPLATE = "name,property_address,city,state,zip_code,phone,email,opportunity_type,mailing_address\nJane Smith,123 Main St,Orlando,FL,32801,4075550100,jane@example.com,Refinance,\"PO Box 12, Orlando, FL 32802\"\n";

export const ImportLeads = ({ onDone }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const ref = useRef(null);
  const template = () => {
    const u = URL.createObjectURL(new Blob([TEMPLATE], { type: "text/csv" }));
    const a = document.createElement("a"); a.href = u; a.download = "elite_leads_import_template.csv"; a.click(); URL.revokeObjectURL(u);
  };
  const upload = async (e) => {
    const f = e.target.files?.[0]; e.target.value = "";
    if (!f) return;
    setBusy(true); setRes(null);
    try { const { data } = await api.post("/prospects/import", { csv_data: await f.text() }); setRes(data); toast.success(`${data.imported} leads imported`); onDone?.(); }
    catch (x) { toast.error(apiError(x)); }
    setBusy(false);
  };
  return (
    <>
      <Button variant="outline" onClick={() => { setRes(null); setOpen(true); }} data-testid="import-leads-btn"><FileUp className="mr-2 h-4 w-4" /> Import leads</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="import-leads-dialog">
          <DialogHeader>
            <DialogTitle>Import your own leads (free)</DialogTitle>
            <DialogDescription>Upload a CSV (up to 1,000 rows). Leads go straight into your list with no AI scoring or contact lookup. Each row needs a name plus an address, phone or email. Homeowners already claimed by another MLO and suppressed contacts are skipped.</DialogDescription>
          </DialogHeader>
          <div className="flex flex-wrap gap-2">
            <Button variant="ghost" size="sm" onClick={template} data-testid="import-template-btn"><Download className="mr-1.5 h-4 w-4" /> CSV template</Button>
            <Button onClick={() => ref.current?.click()} disabled={busy} className="bg-slate-900 hover:bg-slate-800" data-testid="import-upload-btn">
              {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <FileUp className="mr-1.5 h-4 w-4" />} {busy ? "Importing…" : "Choose CSV"}
            </Button>
            <input ref={ref} type="file" accept=".csv,text/csv" className="hidden" onChange={upload} data-testid="import-file-input" />
          </div>
          {res && (
            <div className="rounded-lg bg-slate-50 p-3 text-sm" data-testid="import-result">
              <div className="font-semibold text-slate-900">{res.imported} imported ({res.duplicates} also claimed by other MLOs) · {res.suppressed} suppressed · {res.invalid} invalid</div>
              {res.errors?.length > 0 && <ul className="mt-1 list-disc pl-5 text-xs text-red-600">{res.errors.map((e) => <li key={e}>{e}</li>)}</ul>}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
